<template>
  <div class="table-wrapper">
    <div
      class="button-container"
      :class="
        headerParentId == 6 ||
        headerParentId == 7 ||
        headerParentId == 8 ||
        headerParentId == 9
          ? 'd-flex'
          : ''
      "
    >
      <base-button @click="newItem" v-if="showAddBtn" class="new-btn"
        >{{ label }} Ekle</base-button
      >
      <div
        class="filter-future-date"
        v-if="
          headerParentId == 9 ||
          headerParentId == 8 ||
          headerParentId == 7 ||
          headerParentId == 6
        "
      >
        <h5>Tarih Filtresi</h5>
        <div class="filter-wrapper">
          <button @click="monthToggle('prev')" class="prev">
            <base-icon :name="'arrow-fat-left'" />
          </button>
          <date-picker
            v-model="filterDate"
            :defaultValue="new Date()"
            :clearable="false"
            type="month"
            :placeholder="
              headerParentId === 6 && getManagementAlgoFilter
                ? getManagementAlgoFilter.year +
                  '-' +
                  getManagementAlgoFilter.month
                : headerParentId === 7 && getManagementProductFilter
                ? getManagementProductFilter.year +
                  '-' +
                  getManagementProductFilter.month
                : headerParentId === 8 && getManagementResearchFilter
                ? getManagementResearchFilter.year +
                  '-' +
                  getManagementResearchFilter.month
                : headerParentId === 9 && getManagementForeignFilter
                ? getManagementForeignFilter.year +
                  '-' +
                  getManagementForeignFilter.month
                : ''
            "
            @change="calenderChanged"
          ></date-picker>
          <button @click="monthToggle('next')" class="next">
            <base-icon :name="'arrow-fat-right'" />
          </button>
        </div>

        <h4 v-if="headerParentId == 6">
          <span>
            Listelenen Tarih: {{ getManagementAlgoFilter.month }} /
            {{ getManagementAlgoFilter.year }}
          </span>
        </h4>
        <h4 v-else-if="headerParentId == 7">
          <span>
            Listelenen Tarih: {{ getManagementProductFilter.month }} /
            {{ getManagementProductFilter.year }}
          </span>
        </h4>
        <h4 v-else-if="headerParentId == 8">
          <span>
            Listelenen Tarih: {{ getManagementResearchFilter.month }} /
            {{ getManagementResearchFilter.year }}
          </span>
        </h4>
        <h4 v-else-if="headerParentId == 9">
          <span>
            Listelenen Tarih: {{ getManagementForeignFilter.month }} /
            {{ getManagementForeignFilter.year }}
          </span>
        </h4>
      </div>
    </div>
    <div class="table-container">
      <table>
        <caption></caption>
        <tr>
          <th v-if="haveSort">Sıra</th>
          <th scope="col" v-for="(item, index) in tableHeader" :key="index" :class="String(item.title).trim() == 'Piyasa' ? 'w-30' : ''">
            {{ item.title }}
          </th>
          <th scope="col">İşlem</th>
        </tr>
        <tr v-for="(item, index) in tableData" :key="index">
          <td v-if="haveSort">
            <div class="order-container">
              <div
                class="icon-container"
                @click="
                  changeSortByLocal('up', item, index, tableData.length - 1)
                "
              >
                <base-icon
                  :class-name="
                    index === 0
                      ? 'sort-icon-style disabled-style'
                      : 'sort-icon-style'
                  "
                  :name="'order-arrow-up'"
                />
              </div>
              <div
                class="icon-container"
                @click="
                  changeSortByLocal('down', item, index, tableData.length - 1)
                "
              >
                <base-icon
                  :class-name="
                    index === tableData.length - 1
                      ? 'sort-icon-style disabled-style'
                      : 'sort-icon-style'
                  "
                  :name="'order-arrow-down'"
                />
              </div>
            </div>
          </td>
          <td v-for="(dataItem, columnIndex) in tableHeader" :key="columnIndex" :class="dataItem.title == 'Piyasa' ? 'w-150': '' ">
            <span
              v-if="
                dataItem.column === 'priceType' && item[dataItem.column] == '1'
              "
              >TL</span
            >
            <span
              v-else-if="
                dataItem.column === 'priceType' && item[dataItem.column] == '2'
              "
              >USD</span
            >
            <span
              v-else-if="
                dataItem.column === 'priceType' && item[dataItem.column] == '3'
              "
              >EUR</span
            >
            <span v-else>{{ item[dataItem.column] }}</span>
          </td>
          <td class="w-full">
            <div>
              <span
                v-if="
                  headerParentId != 6 &&
                  headerParentId != 7 &&
                  headerParentId != 8 &&
                  headerParentId != 9
                "
              >
                <base-button @click="edit(item)" class="little-btn"
                  >Düzenle</base-button
                >
              </span>
              <span v-if="item.isActiveVersion || item.isActive">
                <base-button
                  class="little-btn blue"
                  v-if="headerParentId == 6 && item.isActiveVersion != false"
                  @click="
                    showModal(
                      `${item.id}`,
                      `${item.name}`,
                      `${item.id}`,
                      `${item.id}`,
                      `${item.application.id}`
                    )
                  "
                  >Çoğalt</base-button
                >

                <base-button
                  class="little-btn blue"
                  v-else-if="
                    headerParentId == 7 && item.isActiveVersion != false
                  "
                  @click="
                    showModal(
                      `${item.id}`,
                      `${item.applicationTypeName} / ${item.name} / ${item.platformName} / ${item.marketName}`,
                      `${item.platform.id}`,
                      `${item.id}`
                    )
                  "
                  >Çoğalt</base-button
                >

                <base-button
                  class="little-btn blue"
                  v-else-if="
                    headerParentId == 8 && item.isActiveVersion != false
                  "
                  @click="
                    showModal(
                      `${item.id}`,
                      `${item.name}`,
                      `${item.id}`,
                      `${item.id}`
                    )
                  "
                  >Çoğalt</base-button
                >
                <base-button
                  class="little-btn blue"
                  v-else-if="
                    headerParentId == 9 && item.isActiveVersion != false
                  "
                  @click="
                    showModal(
                      `${item.id}`,
                      `${item.name}`,
                      `${item.id}`,
                      `${item.id}`
                    )
                  "
                  >Çoğalt</base-button
                >

                <base-button
                  @click="edit(item)"
                  v-if="item.isActiveVersion != false"
                  class="little-btn"
                  >Düzenle</base-button
                >
                <base-button
                  class="little-btn orange"
                  v-if="
                    headerParentId == 6 ||
                    headerParentId == 7 ||
                    headerParentId == 8
                  "
                  @click="
                    togglePackageActivation(
                      headerParentId == 7 ? item.platform.id : item.id,
                      'deactivate'
                    )
                  "
                  >Paketi İptal Et</base-button
                >
              </span>
              <span v-else>
                <base-button
                  class="little-btn blue"
                  v-if="
                    headerParentId == 6 ||
                    headerParentId == 7 ||
                    headerParentId == 8
                  "
                  @click="
                    togglePackageActivation(
                      headerParentId == 7 ? item.platform.id : item.id,
                      'activate'
                    )
                  "
                  >Paketi Aktif Et</base-button
                >
              </span>

              <base-button
                @click="remove(item)"
                v-if="showRemoveBtn"
                class="little-btn red"
              >
                <span
                  v-if="
                    headerParentId == 6 ||
                    headerParentId == 7 ||
                    headerParentId == 8
                  "
                  >Kaydı Sil</span
                >
                <span v-else>Sil</span>
              </base-button>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <modal height="auto" class="dublicator-modal" :name="modalId">
      <div class="modal-heading">
        <div class="modal-title">
          <h5>Çoğaltma işlemi</h5>
        </div>

        <a @click="closeModal(modalId)">
          <base-icon class="close" name="close-circle" />
        </a>
      </div>
      <div class="modal-body">
        <div class="modal-body__top">
          <div class="modal-body__info">
            <span class="title">Seçilen:</span>
            <span class="block-quote">{{ modalName }}</span>
            <span class="title"
              >Çoğaltmak istediğiniz ürün için tarih seçiniz:</span
            >
            <br />
            <date-picker
              v-model="modal.month"
              type="month"
              placeholder="Tarih seçiniz"
              :disabled-date="disabledBeforeTodayAndAfterAWeek"
              @change="modalCalenderChanged"
            ></date-picker>
            <span></span>
          </div>
          <div class="modal-body__detail">
            <div>İşlemi onaylıyor musunuz?</div>
          </div>
        </div>
      </div>
      <div class="modal-bottom">
        <base-button
          @click="copyItem()"
          :class="{
            disabled:
              modal.isButtonClicked ||
              (modal.payload.month == null && modal.payload.year == null),
          }"
          >Evet</base-button
        >
        <base-button class="warning" @click="closeModal(modalId)"
          >Hayır</base-button
        >
      </div>
    </modal>
  </div>
</template>
<script>
import { BaseButton, BaseIcon } from "@/components";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "GanericTable",
  props: {
    tableHeader: {
      type: Array,
      required: true,
    },
    tableData: {
      type: Array,
      required: false,
    },
    headerParentId: Number,
    onLoadFilterDate: Date,
    showRemoveBtn: Boolean,
    showAddBtn: Boolean,
    remove: Function,
    edit: Function,
    newItem: Function,
    label: String,
    haveSort: Boolean,
    changeSort: Function,
  },
  data() {
    return {
      filterDate: this.onLoadFilterDate ? this.onLoadFilterDate : null,
      modalName: "",
      modalId: "",
      modal: {
        month: "",
        payload: {
          month: null,
          year: null,
          platformId: null,
          featureSettingId: null,
          applicationId: null,
          id: null,
        },
        isButtonClicked: true,
      },
    };
  },
  components: {
    BaseButton,
    BaseIcon,
    DatePicker,
  },
  computed: {
    ...mapGetters([
      "getProductManagementFilter",
      "getProductManagementAlgoFilter",
      "getProductManagementResearchFilter",
      "getProductManagementProductFilter",
      "getProductManagementForeignFilter",
    ]),
    getManagementFilter() {
      return this.getProductManagementFilter;
    },
    getManagementAlgoFilter() {
      return this.getProductManagementAlgoFilter;
    },
    getManagementResearchFilter() {
      return this.getProductManagementResearchFilter;
    },
    getManagementProductFilter() {
      return this.getProductManagementProductFilter;
    },
    getManagementForeignFilter() {
      return this.getProductManagementForeignFilter;
    },
  },
  methods: {
    ...mapActions([
      "copyFeatureSettingItem",
      "copyAlgorithmsItem",
      "copyResearchsItem",
      "copyForeignItem",
      "getFeatureSettingList",
      "getResearchList",
      "getForeignList",
      "getAllAlgorithmAndServers",
      "deActivateAlgorithmAndServer",
      "activateAlgorithmAndServer",
      "deActivateResearch",
      "activateResearch",
      "deActivateFeatureSetting",
      "activateFeatureSetting",
    ]),
    ...mapMutations([
      "setProductPackageAlgoFilter",
      "setProductPackageResearchFilter",
      "setProductPackageProductFilter",
      "setProductPackageForeignFilter",
    ]),
    changeSortByLocal(type, item, index, totalCount) {
      if (
        (index === 0 && type === "up") ||
        (index === totalCount && type === "down")
      ) {
        return;
      }
      item.sortType = type;
      this.changeSort(item);
    },
    disabledBeforeTodayAndAfterAWeek(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      today.setMonth(today.getMonth() - 1);

      return date < today;
      // || date > new Date(today.getTime() + 7 * 24 * 3600 * 1000)
    },
    monthToggle(type) {
      const inputVal = this.filterDate;
      this.$emit("dateToggle", type, inputVal);
    },
    togglePackageActivation(id, type) {
      let args = {
        id: id,
      };

      switch (this.headerParentId) {
        case 6:
          if (type === "deactivate") {
            this.deActivateAlgorithmAndServer(args).then((response) => {
              if (response?.data?.error) {
                this.$toast.error(response.data.message);
              } else {
                this.$emit("activationToggled", true);
                this.$toast.warning("Paket İptal Edildi");
              }
            });
          } else if (type === "activate") {
            this.activateAlgorithmAndServer(args).then((response) => {
              if (response?.data?.error) {
                this.$toast.error(response.data.message);
              } else {
                this.$emit("activationToggled", true);
                this.$toast.success("Aktif Edildi");
              }
            });
          }
          break;

        case 7:
          if (type === "deactivate") {
            this.deActivateFeatureSetting(args).then((response) => {
              if (response?.data?.error) {
                this.$toast.error(response.data.message);
              } else {
                this.$emit("activationToggled", true);
                this.$toast.warning("Paket İptal Edildi");
              }
            });
          } else if (type === "activate") {
            this.activateFeatureSetting(args).then((response) => {
              if (response?.data?.error) {
                this.$toast.error(response.message);
              } else {
                this.$emit("activationToggled", true);
                this.$toast.success("Aktif Edildi");
              }
            });
          }
          break;

        case 8:
          if (type === "deactivate") {
            this.deActivateResearch(args).then((response) => {
              if (response?.data?.error) {
                this.$toast.error(response.data.message);
              } else {
                this.$emit("activationToggled", true);
                this.$toast.warning("Paket İptal Edildi");
              }
            });
          } else if (type === "activate") {
            this.activateResearch(args).then((response) => {
              if (response?.data?.error) {
                this.$toast.error(response.data.message);
              } else {
                this.$emit("activationToggled", true);
                this.$toast.success("Aktif Edildi");
              }
            });
          }
          break;

        default:
          break;
      }
    },
    showModal(
      param,
      modalName,
      platformIdOrId,
      featureSettingId,
      applicationId
    ) {
      this.modal.month = "";
      this.modalId = param;
      this.modalName = modalName;
      this.modal.payload.platformId = Number(platformIdOrId);
      this.modal.payload.featureSettingId = Number(featureSettingId);
      this.modal.payload.applicationId = Number(applicationId);
      this.modal.payload.id = Number(platformIdOrId);
      this.$nextTick(() => {
        this.$modal.show(this.modalId);
      });
    },
    closeModal(param) {
      this.$nextTick(() => {
        this.$modal.hide(param);
        this.modalId = "";
        this.modalName = "";
        this.modal.month = "";
      });
    },
    calenderChanged() {
      this.$emit("filterDataAfterChange", {
        id: this.headerParentId,
        value: this.filterDate?.toJSON(),
      });
    },
    modalCalenderChanged() {
      const unFormatted = JSON.stringify(this.modal.month);
      let splitDateFromTime = unFormatted.split("T")[0];
      let splitHyphen = splitDateFromTime.split("-");
      let getYear = splitHyphen[0].replace('"', "");
      let getMonth = splitHyphen[1];

      this.modal.payload.month =
        Number(getMonth) == 12 ? 1 : Number(getMonth) + 1;
      this.modal.payload.year =
        Number(getMonth) == 12 ? Number(getYear) + 1 : Number(getYear);

      this.modal.isButtonClicked = false;
    },
    copyItem() {
      if (
        this.modal.payload.month == null ||
        this.modal.payload.platformId == null
      ) {
        this.$toast.error("Değerler boş gönderilemez.");
      } else {
        this.modal.isButtonClicked = true;

        switch (this.headerParentId) {
          case 6:
            this.copyAlgorithmsItem(this.modal.payload).then((response) => {
              if (response.error) {
                this.modal.isButtonClicked = false;
                return this.$toast.error(response.message);
              } else {
                this.getAllAlgorithmAndServers({
                  Year: response.year,
                  Month: response.month,
                }).then((reply) => {
                  const servers = reply;
                  for (const item of servers) {
                    item.applicationName = item?.application?.name;
                    item.updateDate = this.$moment(item.updatedAt).format(
                      "DD/MM/YYYY"
                    );

                    if (item.year && item.month) {
                      this.setProductPackageAlgoFilter({
                        year: item.year,
                        month: item.month,
                        inputVal: null,
                      });
                    }
                  }
                  this.$modal.hide(this.modalId);
                  this.$toast.success("Durum güncellendi.");
                  this.$emit("rowCopied", { data: servers });
                });
                this.modal.isButtonClicked = false;
              }
            });
            break;
          case 7:
            this.copyFeatureSettingItem(this.modal.payload).then((response) => {
              if (response.error) {
                this.modal.isButtonClicked = false;
                return this.$toast.error(response.message);
              } else {
                this.getFeatureSettingList({
                  Year: response.year,
                  Month: response.month,
                }).then((reply) => {
                  const formatedData = reply;

                  for (const item of formatedData) {
                    item.platformName = item.platform.name;
                    item.platformId = item.platform.id;
                    const marketNames = [];
                    for (const license of item.licences) {
                      marketNames.push(license.name);
                    }
                    item.marketName = marketNames.join(", ");
                    item.updateDate = this.$moment(item.updatedAt).format(
                      "DD/MM/YYYY"
                    );
                    if (item.year && item.month) {
                      this.setProductPackageProductFilter({
                        year: item.year,
                        month: item.month,
                        inputVal: null,
                      });
                    }
                  }
                  this.$modal.hide(this.modalId);
                  this.$toast.success("Durum güncellendi.");
                  this.$emit("rowCopied", { data: formatedData });
                });
                this.modal.isButtonClicked = false;
              }
            });
            break;
          case 8:
            this.copyResearchsItem(this.modal.payload).then((response) => {
              if (response.error) {
                this.modal.isButtonClicked = false;
                return this.$toast.error(response.message);
              } else {
                this.getResearchList({
                  Year: response.year,
                  Month: response.month,
                }).then((reply) => {
                  const servers = reply;
                  for (const item of servers) {
                    if (!item.application) {
                      item.applicationName = "Ana Ürün";
                    } else {
                      item.applicationName = item.application.name;
                    }
                    item.updateDate = this.$moment(item.updatedAt).format(
                      "DD/MM/YYYY"
                    );

                    if (item.year && item.month) {
                      this.setProductPackageResearchFilter({
                        year: item.year,
                        month: item.month,
                        inputVal: null,
                      });
                    }
                  }
                  this.$modal.hide(this.modalId);
                  this.$toast.success("Durum güncellendi.");
                  this.$emit("rowCopied", { data: servers });
                });
                this.modal.isButtonClicked = false;
              }
            });
            break;
          case 9:
            this.copyForeignItem(this.modal.payload).then((response) => {
              if (response.error) {
                this.modal.isButtonClicked = false;
                return this.$toast.error(response.message);
              } else {
                this.getForeignList({
                  Year: response.year,
                  Month: response.month,
                }).then((reply) => {
                  const servers = reply;
                  for (const item of servers) {
                    if (!item.application) {
                      item.applicationName = "Ana Ürün";
                    } else {
                      item.applicationName = item.application.name;
                    }
                    item.updateDate = this.$moment(item.updatedAt).format(
                      "DD/MM/YYYY"
                    );

                    if (item.year && item.month) {
                      this.setProductPackageForeignFilter({
                        year: item.year,
                        month: item.month,
                        inputVal: null,
                      });
                    }
                  }
                  this.$modal.hide(this.modalId);
                  this.$toast.success("Durum güncellendi.");
                  this.$emit("rowCopied", { data: servers });
                });
                this.modal.isButtonClicked = false;
              }
            });
            break;
          default:
            return Promise.reject(new Error(`Beklenmedik bir hata oluştu`));
        }
      }
    },
  },
  watch: {
    getManagementAlgoFilter: {
      handler: function (newVal) {
        if (this.headerParentId == 6) {
          this.filterDate = newVal.inputVal;
        }
      },
    },
    getManagementResearchFilter: {
      handler: function (newVal) {
        if (this.headerParentId == 8) {
          this.filterDate = newVal.inputVal;
        }
      },
    },
    getManagementProductFilter: {
      handler: function (newVal) {
        if (this.headerParentId == 7) {
          this.filterDate = newVal.inputVal;
        }
      },
    },
    getManagementForeignFilter: {
      handler: function (newVal) {
        if (this.headerParentId == 9) {
          this.filterDate = newVal.inputVal;
        }
      },
    },
  },
  mounted() {
    if (this.headerParentId == 6) {
      this.filterDate = this.getManagementAlgoFilter
        ? new Date(
            this.getManagementAlgoFilter.year +
              "/" +
              this.getManagementAlgoFilter.month
          )
        : null;
    } else if (this.headerParentId == 7) {
      this.filterDate = this.getManagementProductFilter
        ? new Date(
            this.getManagementProductFilter.year +
              "/" +
              this.getManagementProductFilter.month
          )
        : null;
    } else if (this.headerParentId == 8) {
      this.filterDate = this.getManagementResearchFilter
        ? new Date(
            this.getManagementResearchFilter.year +
              "/" +
              this.getManagementResearchFilter.month
          )
        : null;
    } else if (this.headerParentId == 9) {
      this.filterDate = this.getManagementForeignFilter
        ? new Date(
            this.getManagementForeignFilter.year +
              "/" +
              this.getManagementForeignFilter.month
          )
        : null;
    }
  },
};
</script>
<style lang="scss" scoped>
.table-wrapper {
  padding-bottom: 50px;
  .filter-future-date {
    text-align: center;
    @media (min-width: 768px) {
      margin-left: auto;
    }
    h5 {
      margin-bottom: 5px;
    }
    .filter-wrapper {
      display: flex;
      .next,
      .prev {
        border: none;
        background: transparent;
        height: auto;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        transform: scale(1);

        &:hover {
          transform: scale(0.6);
        }
      }
    }
  }
}

.table-width {
  width: 100%;
  max-width: 97%;
}

.button-container {
  @extend .table-width;
  margin: 30px auto;

  &.d-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.table-container {
  @extend .table-width;
  margin: auto;
  text-align: center;
  border: 1px solid #e9e9eb;
  border-radius: 5px;
  font-size: 14px;
  overflow-x: auto;

  table {
    border-collapse: collapse;
    width: 100%;

    tr {
      th {
        border-bottom: 2px solid #e9e9eb;
        padding: 20px 5px;
        box-sizing: border-box;
      }

      td {
        border-bottom: 1px solid #e9e9eb;
        padding: 12px 0px;
        box-sizing: border-box;
        max-width: 100px;
        &.w-150{
          max-width: 170px;
          @media (max-width:1100px) {
            max-width: 140px;
          }
        }
        &.w-full {
          max-width: 290px;
        }
      }

      &:nth-child(odd) {
        background-color: #f9f9fa;
      }

      &:first-of-type {
        background-color: white;
      }
    }
  }
}

.little-btn {
  width: auto;
  height: 31px;
  border-radius: 4px;
  background-color: #28a745;
  margin-right: 5px;
  font-weight: normal;
  font-size: 13px;

  &.red {
    background-color: #dc3545;
  }
  &.orange {
    background-color: #ffa500;
  }
  &.blue {
    background-color: #253ee0;
    margin-left: 0;
  }
}

.new-btn {
  width: auto;
  height: 44px;
  font-size: 16px;
  padding: 0 30px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

.order-container {
  margin: auto;
  height: 40px;
  width: 40px;
  background-color: #f3f3f4;
  border-radius: 50%;
  border: 1px solid #e8e8e8;
  color: #686871;

  .icon-container {
    width: 35px;

    .sort-icon-style {
      display: block;
      margin: auto;
      cursor: pointer;
      width: 19px;
      height: 19px;

      &.disabled-style {
        color: #d4d4d7;
        cursor: unset;
      }
    }
  }
}

.dublicator-modal {
  z-index: 1;

  ::v-deep .vm--modal {
    overflow-y: scroll;

    @media (max-width: 1024px) {
      width: 90% !important;
      left: 50% !important;
      transform: translateX(-50%);
    }
  }

  .modal-heading {
    height: 40px;
    border-bottom: 1px solid var(--grayscale-30);
    display: flex;
    align-items: center;
    padding: 15px 30px;
    justify-content: space-between;

    .close {
      margin: 5px;
      cursor: pointer;
    }
  }

  .modal-bottom {
    margin-top: 1em;
    border-top: 1px solid var(--grayscale-30);
    display: flex;
    justify-content: space-between;
    padding: 15px 30px;

    .base-button {
      background-color: var(--color-primary-default);
      color: var(--grayscale-0);
      width: 180px;
      font-size: 15px;

      &.warning {
        background-color: var(--color-warning);
      }

      &.disabled {
        pointer-events: none;
      }
    }
  }

  .modal-body {
    padding: 15px 30px;

    &__top {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .block-quote {
        background: #e1e1e1;
        border-left: 3px solid #555;
        padding: 10px;
        display: block;
        height: auto;
        margin-bottom: 5px;
      }

      .title {
        display: inline-block;
        text-decoration: underline;
        font-style: italic;
        margin-bottom: 5px;
      }
    }

    &__image {
      .image {
        margin-right: 30px;
        width: 96px;
        height: 140px;
        -o-object-fit: contain;
        object-fit: contain;
      }
    }

    &__detail {
      width: 100%;
      margin-top: 20px;

      .base-form-input {
        ::v-deep input {
          height: 40px;
        }
      }
    }
  }
}
</style>
